import { jsx as r } from "react/jsx-runtime";
import i from "react";
import a from "@mui/material/AlertTitle";
import s from "styled-components";
import { getStatusColor as f } from "../../../theme/utils/styleUtils.js";
const m = {
  root: "alertTitleRoot"
}, p = s(a).withConfig({
  displayName: "StyledAlertTitle"
})([
  "&&.alertTitleRoot{font-weight:",
  ";color:",
  ";line-height:1.2em;margin:0px;}"
], ({ theme: t }) => t.typography.fontWeightBold, ({ theme: t, $severity: e }) => f(t, e)), d = /* @__PURE__ */ i.forwardRef(({ classes: t, severity: e = "info", ...o }, l) => /* @__PURE__ */ r(p, {
  ...o,
  ref: l,
  classes: {
    ...m,
    ...t
  },
  $severity: e
}));
d.displayName = "AlertTitle";
export {
  d as default
};
